import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import VerReclamo from '../../AppComponentsNUtils/ModalVerReclamo';
import GetReclamo from '../../AppComponentsNUtils/GetReclamo';
import AddAntecedente from '../../AppComponentsNUtils/AddAntecedente';
import { validacionPermit } from '../../../../../services/service.user';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import Spinner from '@jumbo/components/custom/Spinner';
import {
  getDatosEntidadesList,
  tableHeadCellsEnEspera,
  validaciones,
  todosLosReclamosActions,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';
import ModalProrroga from '../../AppComponentsNUtils/ModalProrroga';
import RenderFile from 'customComponents/RenderFile';
import { getTodosLosReclamosIf } from 'services/api';

const TablaReclamosPendientes = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showAutoAsignarReclamo, setShowAutoAsignarReclamo] = useState(false);
  const [showProrroga, setShowProrroga] = useState(false);
  const [reclamoAutoAsignar, setReclamoAutoAsignar] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [reclamoProrroga, setReclamoProrroga] = useState(null);
  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);
  /*   const [showAddRec, setShowAddRec] = useState(false); */
  /*   const [reclamoAddRec, setrReclamoAddRec] = useState(null); */

  const [url, setUrl] = useState(undefined);
  const [urlSuper, setUrlSuper] = useState(undefined);

  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewSuper, setShowPreviewSuper] = useState(false);

  const [reload, setReload] = useState(false);

  const loadData = () => {
    setSpinner(true);
    getTodosLosReclamosIf('')
      .then(res => {
        setEntidadesList(
          res.data.map((entidad, index) => {
            return getDatosEntidadesList(entidad);
          }),
        );
      })
      .catch(err => {
        toast.error('Ocurrió un error al buscar reclamos pendientes.');
        console.log(err);
      })
      .finally(e => {
        setSpinner(false);
        setPrimeraCarga(true);
      });
  };

  useEffect(() => {
    loadData();
  }, [reload]);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    } else if (menu.action === 'addRec') {
      /*   setrReclamoAddRec(item); */
      /* setShowAddRec(true); */
    } else if (menu.action === 'autoAsignar') {
      setReclamoAutoAsignar(item);
      setShowAutoAsignarReclamo(true);
    } else if (menu.action === 'prorroga') {
      setReclamoProrroga(item);
      setShowProrroga(true);
    }
  };

  const openModal = fila => {
    setReclamoVer(fila);
    setShowVerReclamo(true);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  /*   const AddRecClose = () => {
    setrReclamoAddRec(null);
    setShowAddRec(false);
  }; */

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const autoAsignarReclamoClose = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
  };

  const autoAsignarReclamoSubmit = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
    setSpinner(true);
    //loadEntidades();
    setReload(!reload);
  };

  const closeModalProrroga = () => {
    setShowProrroga(false);
    setReclamoProrroga(null);
  };

  const closePreview = () => {
    setShowPreview(false);
    setUrl('');
  };

  const cargarUrl = url => {
    setUrl(url);
    setShowPreview(true);
  };

  const closePreviewSuper = () => {
    setShowPreviewSuper(false);
    setUrlSuper('');
  };
  const cargarUrlSuper = url => {
    setUrlSuper(url);
    setShowPreviewSuper(true);
  };

  return (
    validacionPermit('search_reclaim_if') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo
          openDialog={showVerReclamo}
          close={verReclamoClose}
          reclamo={reclamoVer}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
        />
        <AddAntecedente
          uploadType="otroRecurso"
          openDialog={showAddAnt}
          close={AddAntClose}
          reclamo={reclamoAddAnt}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
          setReload={setReload}
          reload={reload}
        />
        {showPreview ? <RenderFile openDialog={showPreview} url={url} close={closePreview} /> : null}
        {showPreviewSuper ? <RenderFile openDialog={showPreviewSuper} url={urlSuper} close={closePreviewSuper} /> : null}
        <ModalProrroga
          openDialog={showProrroga}
          close={closeModalProrroga}
          reclamo={reclamoProrroga}
          reload={reload}
          setReload={setReload}
        />
        <GetReclamo
          openDialog={showAutoAsignarReclamo}
          close={autoAsignarReclamoClose}
          reclamo={reclamoAutoAsignar}
          submit={autoAsignarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1>No hay reclamos pendientes</h1>
          ) : (
            <CustomTable
              headCells={tableHeadCellsEnEspera}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={todosLosReclamosActions}
              handleAction={handleAction}
              openModal={openModal}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosPendientes;
